import * as AttributeActions from '../../../../state/attributes/attributes.action';
import _ from 'lodash';

import template from './tag.create.html';
import deleteConfirmModalTemplate from './_delete.attr.confirmation.modal.html';

const errorStatusText = (error) => (error.statusText ? ` - ${error.statusText}` : '');

class CreateTagController {
  constructor(
    $scope,
    $state,
    $stateParams,
    $location,
    EquipmentService,
    TimezoneService,
    gettextCatalog,
    $uibModal,
    $ngRedux,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.EquipmentService = EquipmentService;
    this.TimezoneService = TimezoneService;
    this.gettextCatalog = gettextCatalog;
    this.$uibModal = $uibModal;
    this.store = $ngRedux;

    this.range = {};
    this.onSave = {};
    this.loading = true;
    this.tagNames = [];
    this.maxDescriptionLength = 255;
    this.dataTypes = {
      Text: 'Text',
      Integer: 'Integer',
      Decimal: 'Decimal',
      Date: 'Date',
      Datetime: 'Datetime',
      Hyperlink: 'Hyperlink',
    };
    this.tag = {
      id: null,
      key: '',
      freeform: false,
      dataType: this.dataTypes.Text,
      values: [],
      range: {},
    };
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, AttributeActions)(this);

    if (this.$stateParams.id) {
      this.fetchTags();
    }

    this.fetchTagNames();
  }

  mapStateToThis(state) {
    const { attributes } = state;

    let readonly = [];
    if (attributes != null && attributes.secured != null && attributes.secured.readonly) {
      readonly = readonly.concat(attributes.secured.readonly);
    }

    return {
      readonlyAttributes: readonly,
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  //Public Methods
  edit() {
    return this.tag.id !== null;
  }

  toggleEntryType(freeForm) {
    this.tag.freeform = freeForm;

    window.dataLayer.push({
      event: 'attributeEntryTypeChanged',
      data: {
        freeForm: this.tag.freeform,
      },
    });
  }

  setDataType(dataType) {
    this.tagForm.$submitted = false;
    this.tag.range = {};
    this.tag.values = [];
    this.tag.dataType = dataType;
    window.dataLayer.push({
      event: 'attributeDataTypeChanged',
      data: {
        dataType: this.tag.dataType,
      },
    });
  }

  getButtonClass(tab) {
    return tab === this.tag.dataType ? 'btn-primary' : 'btn-default';
  }

  nameExists(name) {
    return (
      name &&
      -1 !== this.tagNames.indexOf(name.toLowerCase()) &&
      name.toLowerCase() !== this.tag.key.toLowerCase()
    );
  }

  valid(name) {
    return name != null && this.readonlyAttributes.indexOf(name.toLowerCase()) === -1;
  }

  hasError(field, validation) {
    if (validation) {
      return (
        (this.tagForm[field].$dirty && this.tagForm[field].$error[validation]) ||
        (this.tagForm.$submitted && this.tagForm[field].$error[validation])
      );
    }
    return (
      (this.tagForm[field].$dirty && this.tagForm[field].$invalid) ||
      (this.tagForm.$submitted && this.tagForm[field].$invalid)
    );
  }

  submittagForm() {
    if (
      this.tagForm.$invalid ||
      !this.valid(this.tag.key) ||
      this.nameExists(this.tag.key) ||
      this.sending
    ) {
      return;
    }
    this.sending = true;
    if (!this.tag.freeform) {
      this.onSave.invoke();
    }

    this.edit() ? this.putTag() : this.postTag();
  }

  delete() {
    const tag = this.tag;
    this.$uibModal.open({
      animation: true,
      template: deleteConfirmModalTemplate,
      backdropClass: 'tr-attribute-delete-dismiss',
      controller: 'TagDeleteModalController',
      resolve: {
        tag: function () {
          return tag;
        },
      },
      size: 'md',
    });
  }

  cancel() {
    this.$state.go('admin.tag-details', {
      id: this.tag.id,
    });
  }

  //Private Methods
  handleError(error) {
    let errorMsg = this.gettextCatalog.getString('An error occurred');
    if (error.data || error.status) {
      if (error.data.Message) {
        if (error.data.Message.includes('already exists'))
          errorMsg = 'Attribute name already exists.';
        else errorMsg = error.data.Message + errorStatusText(error);
      } else {
        errorMsg += errorStatusText(error);
      }
    } else {
      errorMsg += this.gettextCatalog.getString('. Please try again later.');
    }
    this.errorFlag = true;
    this.errorText = errorMsg;
    this.sending = false;
    this.loading = false;
  }

  fetchTags() {
    const me = this;
    return this.EquipmentService.getTagById(this.$stateParams.id).then((response) => {
      me.tag = response.data;

      if (me.tag.dataType === me.dataTypes.Datetime) {
        if (me.tag.range.min) {
          me.tag.range.min = me.TimezoneService.tagToUserTimezone(me.tag.range.min);
        }
        if (me.tag.range.max) {
          me.tag.range.max = me.TimezoneService.tagToUserTimezone(me.tag.range.max);
        }
      }
      me.$scope.$emit('$viewContentLoaded'); //breadcrumb fix;
    }, this.handleError);
  }

  fetchTagNames() {
    const me = this;
    return this.EquipmentService.getTagNames().then((response) => {
      me.tagNames = response.data;
      for (let i = 0; i < me.tagNames.length; i++) {
        me.tagNames[i] = me.tagNames[i].toLowerCase();
      }
      me.loading = false;
    }, this.handleError);
  }

  putTag() {
    const me = this;
    this.EquipmentService.putEditTag(this.tag.id, this.tag).then((response) => {
      me.createAttribute();

      me.$state.go('admin.tag-details', {
        id: response.data.id,
      });
    }, this.handleError.bind(this));
  }

  postTag() {
    let tag = _.clone(this.tag, true);
    const me = this;
    this.EquipmentService.postNewTag(tag).then((response) => {
      me.createAttribute();

      me.$state.go('admin.tag-details', {
        id: response.data.id,
      });
    }, this.handleError.bind(this));
  }

  nameChanged() {
    window.dataLayer.push({
      event: this.edit() ? 'attributeEditNameChanged' : 'attributeNameChanged',
    });
  }

  descriptionChanged() {
    window.dataLayer.push({
      event: this.edit() ? 'attributeEditDescriptionChanged' : 'attributeDescriptionChanged',
    });
  }
}

export const CreateTagComponent = {
  template,
  controller: CreateTagController,
  controllerAs: 'vm',
  bindings: {},
};
